var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63754 11.5C1.78754 11.5 1.78754 13.2154 1.78754 15.3333V16.2917C1.78754 18.9367 1.78754 21.0833 6.60004 21.0833H14.3C18.15 21.0833 19.1125 18.9367 19.1125 16.2917V15.3333C19.1125 13.2154 19.1125 11.5 15.2625 11.5C14.3 11.5 14.0305 11.7013 13.53 12.075L12.5483 13.11C11.4125 14.3175 9.48754 14.3175 8.34216 13.11L7.37004 12.075C6.86954 11.7013 6.60004 11.5 5.63754 11.5Z",
    stroke: "#D44A00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 11.5001V5.75008C17.1875 3.63216 17.1875 1.91675 13.3375 1.91675H7.56252C3.71252 1.91675 3.71252 3.63216 3.71252 5.75008V11.5001",
    stroke: "#D44A00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05438 8.84546H12.2595",
    stroke: "#D44A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25555 5.97046H13.0681",
    stroke: "#D44A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectbox);
export default __webpack_public_path__ + "static/media/directbox.41016f4e7d02d0fa0835fadc77318d29.svg";
export { ForwardRef as ReactComponent };